module.exports = __webpack_public_path__ + "img/changZuiHu2.78f4d4c3.png";